import React, { useState } from "react";
import PerformanceAnalysisTabs from "./PerformanceAnalysisTabs";
import PerformanceAnalysisChampionCircle from "./PerformanceAnalysisChampionCircle";

const PerformanceAnalysisMostPlayedChamps = (props) => {
  const { mostPlayedChamps } = props;
  const [currentRoleNum, setCurrentRoleNum] = useState(0);

  const switchRole = (index) => {
    setCurrentRoleNum(index);
  };

  const abbrRoleToFull = (role) => {
    const abbrMap = {
      adc: "BOT",
      supp: "SUPPORT",
      mid: "MID",
      top: "TOP",
      jungle: "JUNGLE",
    };

    if (abbrMap[role]) return abbrMap[role];
    return role;
  };

  if (!mostPlayedChamps) {
    return null;
  }

  const tabs = mostPlayedChamps.map((role, index) => {
    return {
      label: abbrRoleToFull(role.roleName),
      callback: () => switchRole(index),
    };
  });

  const roles = mostPlayedChamps.map((role) => {
    return role.topChamps.map((champion) => {
      return {
        champID: champion.championId,
        statText: `${(champion.winRate * 100).toFixed(1)}%`,
        label: "Winrate",
        secondaryText: `${champion.gamesPlayed} GAMES`,
      };
    });
  });

  return (
    <div className="most-played-champs">
      <div className="small-header">YOUR MOST PLAYED CHAMPS</div>
      <div className="most-played-champs_tabs">
        <PerformanceAnalysisTabs tabsData={tabs} />
      </div>
      <div className="circles-list">
        {roles[currentRoleNum].map((roleData, index) => {
          return <PerformanceAnalysisChampionCircle key={index} isLarge={true} data={roleData} />;
        })}
      </div>
    </div>
  );
};

export default PerformanceAnalysisMostPlayedChamps;
